import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-claim-detail-document',
  templateUrl: './claim-detail-document.component.html',
  styleUrls: ['./claim-detail-document.component.scss'],
  standalone: true,
  imports: [ MatIcon ]
})
export class ClaimDetailDocumentComponent {

  @Input() fileName!: string;
  @Input() description!: string;

}